import useTranslation from 'next-translate/useTranslation';
import { Title } from './Title';
import Image from 'next/image';

function ContactSection() {
  const { t } = useTranslation();

  return (
    <div className='space-y-6'>
      <Title title={t('services:Contact.title')} />
      <div className='space-y-10'>
        <div className='inline'>
          {t('services:Contact.text')}
          <a href='/contact' className='ml-2  font-medium underline'>
            {t('services:Contact.button')}
          </a>
        </div>
        <div className='flex w-full items-center justify-center gap-8 '>
          <div className='relative h-[8rem] w-[8rem] overflow-hidden rounded-3xl border-8 border-orange-400'>
            <Image
              src='/profile_carsten.png'
              alt='Image of Carsten Hormes'
              fill
              className='object-cover'
            />
          </div>
          <div className='flex flex-col justify-end'>
            <div>
              <h3 className=' font-semibold'>Carsten Hormes</h3>
              <h3 className=''>{t('common:Managing Director Engineering')}</h3>
            </div>
            <div>
              <address>
                <h3 className=''>
                  <a href='tel:+49 173 90 80 414' className='link'>
                    +49 173 90 80 414
                  </a>
                </h3>
                <h3 className=''>
                  <a href='mailto:c.hormes@bevmaq.com' className='link'>
                    c.hormes@bevmaq.com
                  </a>
                </h3>
              </address>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactSection;
